<template>
  <div>
    <!-- alerta -->
    <Alert
      :alert="alert"
      :type="alertType"
      :title="alertTitle"
      :message="alertMessage"
    />

    <!-- formulario -->
    <v-row justify="center">
      <v-col
        sm="1"
        lg="2"
        class="hidden-xs-only"
      >
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              fab
              small
              fixed
              exact
              color="primary"
              v-bind="attrs" 
              v-on="on" 
              @click="regresar"
            >
              <v-icon>
                mdi-arrow-left
              </v-icon>
            </v-btn>
          </template>
          <span>Regresar</span>
        </v-tooltip>
      </v-col>
      <v-col 
        cols="12" 
        sm="10" 
        lg="8"
      >
        <v-card 
          outlined 
          elevation="2" 
          :loading="loadingForm"
        >
          <v-card-title class="justify-center">
            <p class="text-h4 font-weight-bold primary--text mt-2">
              Actualizar Saber
            </p>
          </v-card-title>
          <v-card-text>
            <v-row justify="center">
              <v-col 
                cols="12" 
                sm="10" 
                lg="8"
              >
                <v-form ref="form" v-model="form">
                

                 <v-textarea
                   outlined
                   label="Saber*"
                   rows="4"
                   v-model="saber"
                   :rules="saberReglas"
                 ></v-textarea>

                  <v-textarea
                    outlined
                    rows="4"
                    label="Descripción"
                    v-model="descripcion"
                  >
                  </v-textarea>

                  <v-btn
                    large
                    block
                    exact
                    elevation="2"
                    color="primary"
                    class="mt-2 mb-6"
                    @click="actualizar"
                  >
                    Actualizar
                  </v-btn>
                </v-form>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import Alert from '../../../components/admin/Alert.vue'

export default {
  data: () => ({
    alert: false,
    alertType: '',
    alertTitle: '',
    alertMessage: '',

    form: true,
    loadingForm: false,

    
    saber: '',
    saberReglas: [
      v => !!v || "Escribe un saber"
    ],
    
    descripcion: '',

     }),

  mounted() {
   
    this.$store.dispatch("obtenerSaberCampesenaId", {
      idCategoria: this.$route.params.idCategoria,
      idSaber: this.$route.params.idSaber,
    })
    setTimeout(() => {
      const data = this.saberActualizar
      this.saber            = data.saber;
      this.descripcion      = data.descripcion; 
    }, 1000);
   
  },
  computed:{
    saberActualizar() {
      return this.$store.getters.obtenerSaber;
    },
  },

  components: {
    Alert 
  },

  methods: {
    actualizar() {
      if (this.$refs.form.validate()) {
        this.loadingForm = true;

        const saber = {
          id:                   this.$route.params.idSaber,
          saber:                this.saber.toLowerCase(),
          descripcion:          this.descripcion,
          Categoria_id:         this.$route.params.idCategoria,
        };
       
        this.$store.dispatch("actualizarSaberCampesena", {idCategoria:this.$route.params.idCategoria, idSaber:this.$route.params.idSaber,saber:saber})
        .then((response) => {
          if (response.status == "success") {
            this.loadingForm  = false;
            let message = response.message.split(',')
            this.alertType    = "success--text";
            this.alertTitle   = message[0];
            this.alertMessage = message[1];
            this.alert        = true;

            setTimeout(() => {
              this.alert = false
              this.$router.replace({ name: 'campesena-saber-gestionar' })
            }, 2000)
          }
          else {
            this.loadingForm  = false
            this.alertType    = "error--text";
            this.alertTitle   = "Error";
            for (const error in response.message) {
              this.alertMessage = response.message[error][0]
            }
            this.alert = true;

            setTimeout(() => {
              this.alert = false
            }, 3000)
          }
        })
        .catch(() => {});
      }
    },

    validarFecha() {
      if (this.modalFechaInicio) {
        this.modalFechaInicio = false
      }

      if (this.modalFechaFin) {
        this.modalFechaFin = false
      }
      
      if ((this.fechaInicio != null) && (this.fechaFin != null)) {
        const fecha1 = new Date(this.fechaInicio)
        const fecha2 = new Date(this.fechaFin)
        if (fecha1 >= fecha2) {
          this.fechaFin     = null
          this.fechaInicio  = null
          
          this.alertType    = "error--text";
          this.alertTitle   = "Error";
          this.alertMessage = "Fecha inicio mayor a fecha fin";
          this.alert        = true;

          setTimeout(() =>{
            this.alert = false
          }, 2000)
        }
      }
    },

    regresar() {
      this.$router.back()
    }
  }
};
</script>